import React from "react";
import Header from "../Components/Header";
import Navigation from "../Components/Navigation";
import InfiniteCarousel from "../Components/InfiniteCarousel ";
import Advantages from "../Components/Advantages";
import Offers from "../Components/Offers";
import Whyme from "../Components/Whyme";
import FAQ from "../Components/FAQ";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";

const Home = () => {
  return (
    <div className="container-fluid">
      <Navigation />
      <div className=" pt-5">
        <Header />
        <InfiniteCarousel />
        <Advantages />
        <Offers />
        <Whyme />
        <FAQ />
        <Contact />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
